module.exports = require("d3-time");


/*****************
 ** WEBPACK FOOTER
 ** external "d3-time"
 ** module id = 13
 ** module chunks = 0 1
 **/